import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgShield = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m33.157 9.23-12-5a3.01 3.01 0 0 0-2.307 0l-12.001 5A2.997 2.997 0 0 0 4.999 12c0 12.407 7.157 20.983 13.845 23.77a3.01 3.01 0 0 0 2.306 0C26.507 33.54 35.002 25.832 35.002 12a3.001 3.001 0 0 0-1.845-2.77Zm-2.95 7.138-11.5 11.502a1.003 1.003 0 0 1-1.413 0l-6.501-6.501a1.004 1.004 0 0 1 0-1.413l1.413-1.412a1.004 1.004 0 0 1 1.412 0L18 22.925l9.382-9.382a1.004 1.004 0 0 1 1.413 0l1.412 1.413a.992.992 0 0 1 0 1.412Z" })
});
export default SvgShield;
